import styled from 'styled-components';
import { TypographyStyles, colours, maxWidthPartial, media, spacing } from '../../../stylings';

export const Nav = styled.nav<{ $forDesktop: boolean }>`
  display: ${({ $forDesktop }) => $forDesktop && 'none'};
  margin-top: ${({ $forDesktop }) => ($forDesktop ? 'initial' : '16px')};

  @media ${media.greaterThan('lg')} {
    background-color: ${colours.MEDIUM_GREY};
    display: ${({ $forDesktop }) => $forDesktop && 'block'};
  }
`;

export const NavList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XS};
  ${maxWidthPartial({ withPaddingXL: true })}

  @media ${media.greaterThan('lg')} {
    align-items: center;
    flex-direction: row;
    height: 33px;
    justify-content: flex-end;
    list-style: none;
  }
`;

export const NavItem = styled.li`
  a {
    color: ${colours.BLACK};
    display: flex;
    padding: 1px 0;
    text-decoration: none;
    &:hover,
    &:focus {
      text-decoration: underline;
    }

    @media ${media.greaterThan('lg')} {
      align-items: center;
      justify-content: center;
    }
  }
`;

export const Label = styled.span`
  ${TypographyStyles.Body.Small.Regular}
  padding: 0 ${spacing.XXS};

  @media ${media.greaterThan('lg')} {
    ${TypographyStyles.Body.Tiny.Regular}
    padding: 0 0 0 ${spacing.XXS};
  }
`;

export const LogoutBtn = styled.button`
  align-items: center;
  background-color: inherit;
  border: none;
  color: ${colours.BLACK};
  display: flex;
  margin: 0;
  padding: 0;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;
